[
  {
    "id": "change-muse-spark-1-2-launch",
    "claimId": "muse-spark-1-2-launch",
    "changedAt": "2026-08-05T16:00:00.000Z",
    "action": "added",
    "note": "Added Meta's official Muse Spark 1.2 and Muse Code announcement."
  },
  {
    "id": "change-qwen3-8-max-announcement",
    "claimId": "qwen3-8-max-announcement",
    "changedAt": "2026-08-03T12:00:00.000Z",
    "action": "added",
    "note": "Added Alibaba's official Qwen3.8-Max announcement; weights remain unverified."
  },
  {
    "id": "change-openai-ten-math-advances",
    "claimId": "openai-ten-math-advances-report",
    "changedAt": "2026-08-01T15:00:00.000Z",
    "action": "added",
    "note": "Added OpenAI's primary report and explicit independent-review boundary."
  },
  {
    "id": "change-claude-opus-5-launch",
    "claimId": "claude-opus-5-launch",
    "changedAt": "2026-07-24T15:00:00.000Z",
    "action": "added",
    "note": "Added Anthropic's official Claude Opus 5 release."
  },
  {
    "id": "change-gpt-5-6-sol-launch",
    "claimId": "gpt-5-6-sol-launch",
    "changedAt": "2026-07-09T15:00:00.000Z",
    "action": "added",
    "note": "Added OpenAI's official GPT-5.6 general-availability release."
  }
]

